import React from "react";
import { connect } from "react-redux";
import { HashRouter, Route as SimpleRoute, Switch } from "react-router-dom";
import Redirect from "./connected-redirect";
import { selectors as searchSelectors } from "../redux/search"; // TODO ideally this doesn't live here and it's a pure non connected component
import { selectors as brandSelectors } from "../redux/brand";
import { selectors as userSelectors } from "../redux/user";
import { selectors as routerSelectors } from "../redux/router";
import ConnectedRoute from "./connected-route";
import UserRoutes from "./user-routes";
import Spinner from "../components/layouts/spinner";
import Activate from "../ui/apps/activate";
import LibraryOrDownloadApps from "../ui/apps/library/library-or-download-apps";

const Router = ({
  isFullUser,
  hasAcceptedEULA,
  ssoOnly,
  signinRedirect,
  authenticated,
  verified,
  emailParam,
  query,
  queryAfter,
  queryAfterEULA
}) => (
  <HashRouter basename="/">
    <Switch>
      {/*<ConnectedRoute path="/" exact component={Library} authenticated={authenticated} userInfo={userInfo} />*/}
      <Redirect from="/new-library" to="/" />
      <Redirect exact from="/books" to="/" />
      <Redirect
        from="/books/bookshelf"
        to={
          query
            ? location.hash.split("?")[1]
              ? `/search?${location.hash.split("?")[1]}`
              : "/"
            : "/"
        }
      />
      <ConnectedRoute path="/" exact component={LibraryOrDownloadApps} />
      <ConnectedRoute path="/classes" component={LibraryOrDownloadApps} />
      <ConnectedRoute path="/groups" component={LibraryOrDownloadApps} />
      <ConnectedRoute path="/explore" component={LibraryOrDownloadApps} />
      <ConnectedRoute path="/admin" component={LibraryOrDownloadApps} />
      <ConnectedRoute path="/interactives" component={LibraryOrDownloadApps} />
      <ConnectedRoute path="/search" component={LibraryOrDownloadApps} />
      <Redirect exact from="/activation" to="/user/activation" />
      <Redirect exact from="/forgot" to="/user/forgot" />
      <Redirect exact from="/user/edit" to="/user/complete" />
      <Redirect exact from="/user/new" to="/user/registration" />
      <Redirect exact from="/user/registration/new" to="/user/registration" />
      <Redirect exact from="/terms" to="/user/terms" />
      <Redirect exact from="/home/eula" to="/user/terms" />
      {hasAcceptedEULA && (
        <Redirect exact from="/user/terms" to={queryAfterEULA || "/"} />
      )}
      {authenticated && <Redirect exact from="/user/signin" to={"/"} />}
      {verified && <Redirect exact from="/verify" to={"/"} />}
      {authenticated && !emailParam && (
        <Redirect exact from="/user/registration" to={"/"} />
      )}
      {(ssoOnly || isFullUser) && (
        <Redirect exact from="/user/sso" to={queryAfter || "/"} />
      )}
      {isFullUser && (
        <Redirect exact from="/user/decide" to={queryAfter || "/"} />
      )}
      {signinRedirect && (
        <Redirect from="/user/signin" to={signinRedirect} external />
      )}
      {UserRoutes.map(route => {
        const { condition = true, redirect, ...props } = route;
        if (redirect) {
          if (condition) {
            return <Redirect key={props.path} {...props} />;
          }
        } else {
          return <ConnectedRoute key={props.path} {...props} />;
        }
        return null;
      })}
      {/*
                <ConnectedRoute
                  path="/playground/*"
                  component={Playgrounds}
                  skipRedirect
                  skipSSO
                  skipTOS
                />*/}

      {/* Want to show a spinner while opening books from new router */}
      <SimpleRoute from="/books/*" component={Spinner} />

      <ConnectedRoute
        path="/activate/:isbn/:locationType?/:location*"
        component={Activate}
      />

      <SimpleRoute
        component={() => <Fraction.Error errorCode="404" delayRender />}
      />
      {/*<ConnectedRoute
                  path="/books/:isbn/*"
                  component={({match}) => (
                    <Fraction.Reader
                      isbn={match.params.isbn}
                      initialPage={'recent'}
                      route={`/books/${match.params.isbn}/${location.search.replace(/\/$/, "")}`}
                    />
                  )}
                  authenticated={authenticated}
                  userInfo={userInfo}
                />
                <ConnectedRoute
                  path="/user/signin"
                  exact
                  component={({ match }) => (
                    <Fraction.UserPage
                      page="signin"
                      status={status}
                      email={match.params.email}
                      captcha={match.params.captcha} />
                  )}
                  />*/}
    </Switch>
  </HashRouter>
);

const mapStateToProps = state => ({
  authenticated: userSelectors.isAuthenticated(state),
  verified:
    userSelectors.isAuthenticated(state) &&
    (!userSelectors.requiresEmailVerification(state) ||
      userSelectors.emailIsVerified(state)),
  isFullUser: !userSelectors.isReferenceUser(state),
  hasAcceptedEULA: userSelectors.hasAcceptedTOU(state),
  signinRedirect: brandSelectors.getBrandValue(state, "Signin.redirect", false),
  ssoOnly: brandSelectors.getBrandValue(
    state,
    "AccountCompletion.ssoOnly",
    true
  ),
  query: searchSelectors.getCurrentQuery(state),
  emailParam: routerSelectors.getQueryParam(state, "email"),
  queryAfter: routerSelectors.getQueryParam(state, "after"),
  queryAfterEULA: routerSelectors.getQueryParam(state, "after_eula")
});

export default connect(mapStateToProps)(Router);
